import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {alertActions, breadcrumbsActions, persistor} from '../store';
import { history } from '../helpers';
import {customAxios} from "../functions/custom_axios";

const name = 'auth';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState, reducers });



export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;



function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        //value: JSON.parse(localStorage.getItem('auth'))
        value: null,
        token_expires_in_ms: null,
        token_expiry_time_in_ms: null,
        loggedInuser: null,
        accessTo: {
            SUPER_ADMIN_ONLY: false,
            ADMIN_AND_ABOVE: false,
            ANALYST_AND_ABOVE: false,
            USER_AND_ABOVE: false,
            PROSPECT_AND_ABOVE: false,
            ADMIN_ONLY: false,
            ANALYST_ONLY: false,
            USER_ONLY: false,
            PROSPECT_ONLY: false
        }
    }
}

function createReducers() {
    return {
        setAuth,
        getAuth,
        setTokenExpiresInMs,
        setLoggedInUser,
        setAccessTo
    };

    function setAuth(state, action) {
        state.value = action.payload;
    }

    function getAuth(state) {
        return state.value;
    }

    function setTokenExpiresInMs(state, action) {
        state.token_expires_in_ms = action.payload;
        try {
            if (state.token_expires_in_ms) {
                state.token_expiry_time_in_ms = new Date().getTime() + state.token_expires_in_ms;
            } else {
                state.token_expiry_time_in_ms = null;
            }
        } catch (error) {
            state.token_expiry_time_in_ms = null;
        }
    }

    function setLoggedInUser(state, action) {
        state.loggedInUser = action.payload;
        setAccessTo(state, null);

        const primary_role = (state.loggedInUser?.roles.length > 0) ? state.loggedInUser?.roles[0] : null;
        if (primary_role && primary_role.name) {
            setAccessTo(state, primary_role.name);
        }
    }

    function setAccessTo(state, primary_role_name) {
        switch (primary_role_name) {
            case 'ROLE_SUPER_ADMIN':
                state.accessTo = {
                    SUPER_ADMIN_ONLY: true,
                    ADMIN_AND_ABOVE: true,
                    ADMIN_ONLY: false,
                    ANALYST_AND_ABOVE: false,
                    USER_AND_ABOVE: false,
                    PROSPECT_AND_ABOVE: false,
                    ANALYST_ONLY: false,
                    USER_ONLY: false,
                    PROSPECT_ONLY: false
                };
                break;
            case 'ROLE_ADMIN':
                state.accessTo = {
                    SUPER_ADMIN_ONLY: false,
                    ADMIN_AND_ABOVE: true,
                    ADMIN_ONLY: true,
                    ANALYST_AND_ABOVE: true,
                    USER_AND_ABOVE: true,
                    PROSPECT_AND_ABOVE: true,
                    ANALYST_ONLY: false,
                    USER_ONLY: false,
                    PROSPECT_ONLY: false
                };
                break;
            case 'ROLE_ANALYST':
                state.accessTo = {
                    SUPER_ADMIN_ONLY: false,
                    ADMIN_AND_ABOVE: false,
                    ADMIN_ONLY: false,
                    ANALYST_AND_ABOVE: true,
                    USER_AND_ABOVE: true,
                    PROSPECT_AND_ABOVE: true,
                    ANALYST_ONLY: true,
                    USER_ONLY: false,
                    PROSPECT_ONLY: false
                };
                break;
            case 'ROLE_USER':
                state.accessTo = {
                    SUPER_ADMIN_ONLY: false,
                    ADMIN_AND_ABOVE: false,
                    ADMIN_ONLY: false,
                    ANALYST_AND_ABOVE: false,
                    USER_AND_ABOVE: true,
                    PROSPECT_AND_ABOVE: true,
                    ANALYST_ONLY: false,
                    USER_ONLY: true,
                    PROSPECT_ONLY: false
                };
                break;
            case 'ROLE_PROSPECT':
                state.accessTo = {
                    SUPER_ADMIN_ONLY: false,
                    ADMIN_AND_ABOVE: false,
                    ADMIN_ONLY: false,
                    ANALYST_AND_ABOVE: false,
                    USER_AND_ABOVE: false,
                    PROSPECT_AND_ABOVE: true,
                    ANALYST_ONLY: false,
                    USER_ONLY: false,
                    PROSPECT_ONLY: true
                };
                break;
            default:
                state.accessTo = {
                    SUPER_ADMIN_ONLY: false,
                    ADMIN_AND_ABOVE: false,
                    ADMIN_ONLY: false,
                    ANALYST_AND_ABOVE: false,
                    USER_AND_ABOVE: false,
                    PROSPECT_AND_ABOVE: true,
                    ANALYST_ONLY: false,
                    USER_ONLY: false,
                    PROSPECT_ONLY: true
                };
                break;
        }
    }
}

function createExtraActions() {

    return {
        login: login(),
        logout: logout(),
        getAuth: getAuth(),
        getTokenExpiryTimeInMs: getTokenExpiryTimeInMs(),
        extendToken: extendToken(),
        resetPassword: resetPassword(),
        resetPassword_v2: resetPassword_v2(),

        updatePassword: updatePassword()
    };

    function login() {
        return createAsyncThunk(
            `${name}/login`,
            async function ({ email, password }, { dispatch }) {
                dispatch(alertActions.clear());
                try {
                    const response = await customAxios.post(`/open-api/login`, { email, password });
                    const token = (response && response.data && response.data.data) ? response.data.data.token : null;
                    const tokenExpiresInMs = (response && response.data && response.data.data) ? response.data.data.tokenExpiresInMs : null;
                    const loggedInUser = (response && response.data && response.data.data) ? response.data.data.loggedInUser : null;

                    const message = (response && response.data) ? response.data.message : "";
                    const error = (response && response.data) ? response.data.error : "";

                    // set auth user in redux state
                    if (message) {
                        //console.log('message: '+JSON.stringify(message));
                    }
                    if (token) {
                        await dispatch(authActions.setAuth(token));
                        await dispatch(authActions.setTokenExpiresInMs(tokenExpiresInMs));
                        await dispatch(authActions.setLoggedInUser(loggedInUser));
                        await dispatch(breadcrumbsActions.setSelectedMenuIndex(0));
                        // localStorage.setItem('auth', token);
                        // localStorage.setItem('loggedInUser', JSON.stringify(loggedInUser));
                        // get return url from location state or default to home page
                        const { from } = history.location.state || { from: { pathname: '/home' } };

                        history.navigate(from);
                    } else {
                        if(error) {
                            dispatch(alertActions.error(error));
                        }
                    }
                } catch (error) {
                    //Info: Error will be handled by "customAxios.interceptors.response.use" function
                }
            }
        );
    }

    function logout() {
        return createAsyncThunk(
            `${name}/logout`,
            async function (arg, { dispatch }) {
                await dispatch(authActions.setAuth(null));
                await dispatch(authActions.setTokenExpiresInMs(null));
                await dispatch(authActions.setLoggedInUser(null));
                await dispatch(authActions.setAccessTo(null));
                await dispatch(breadcrumbsActions.setSelectedMenuIndex(0));
                await persistor.purge();
                await persistor.flush();
                // localStorage.removeItem('auth');
                // localStorage.removeItem('loggedInUser');
                history.navigate('/account/login', { replace: true });
            }
        );
    }

    function getAuth() {
        return createAsyncThunk(
            `${name}/getAuth`,
            async function (args, { getState }) {
                try {
                    const token = getState().auth.value;
                    return token;
                } catch (error) {
                    return null;
                }
            }
        );
    }

    function getTokenExpiryTimeInMs() {
        return createAsyncThunk(
            `${name}/getTokenExpiryTimeInMs`,
            async function (args, { getState }) {
                try {
                    const tokenExpiryTimeInMs = await getState().auth.token_expiry_time_in_ms;
                    return tokenExpiryTimeInMs;
                } catch (error) {
                    return -1;
                }
            }
        );
    }

    function extendToken() {
        return createAsyncThunk(
            `${name}/extendToken`,
            async function (args, { getState, dispatch }) {
                dispatch(alertActions.clear());
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`,
                    };
                    const response = await customAxios.get(`/api/customized/user/extend_token`, { headers });
                    const newToken = (response && response.data && response.data.data) ? response.data.data.token : null;
                    const tokenExpiresInMs = (response && response.data && response.data.data) ? response.data.data.tokenExpiresInMs : null;
                    const loggedInUser = (response && response.data && response.data.data) ? response.data.data.loggedInUser : null;

                    const message = (response && response.data) ? response.data.message : "";
                    const error = (response && response.data) ? response.data.error : "";

                    if (message) {
                        //console.log('message: '+JSON.stringify(message));
                    }
                    // set auth user in redux state
                    if (newToken) {
                        await dispatch(authActions.setAuth(newToken));
                        await dispatch(authActions.setTokenExpiresInMs(tokenExpiresInMs));
                        await dispatch(authActions.setLoggedInUser(loggedInUser));
                    } else {
                        await dispatch(alertActions.error(error));
                    }
                    return null;
                } catch (error) {
                    await dispatch(alertActions.error(error));
                    return null;
                }
            }
        );
    }

    function resetPassword() {
        return createAsyncThunk(
            `${name}/resetPassword`,
            async function ({ email }, { dispatch }) {
                dispatch(alertActions.clear());
                let message;
                try {
                    const response = await customAxios.post(`/open-api/user/resetPassword?email=${email}&clientAppId=2`);
                    // set auth user in redux state
                    if (response) {
                        console.log('message: ' + JSON.stringify(response));
                    }
                    message = response.data;
                } catch (error) {
                    dispatch(alertActions.error(error));
                    message = error;
                }
                if (message) {
                    dispatch(alertActions.success({ message, showAfterRedirect: true }));
                }
                history.navigate('/account/login');
            }
        );
    }

    function resetPassword_v2() {
        return createAsyncThunk(
            `${name}/resetPassword`,
            async function ({ email }, { dispatch }) {
                dispatch(alertActions.clear());
                let message;
                try {
                    const response = await customAxios.post(`/open-api/user/resetPassword?email=${email}&clientAppId=2`);
                    // set auth user in redux state
                    if (response) {
                        console.log('message: ' + JSON.stringify(response));
                    }
                    message = response.data;
                    return message;
                } catch (error) {
                    // dispatch(alertActions.error(error));
                    message = error;
                    return error;
                }
                // if (message) {
                //     dispatch(alertActions.success({ message, showAfterRedirect: false }));
                //     return message;
                // }
                // history.navigate('/account/login');
            }
        );
    }

    function updatePassword() {
        return createAsyncThunk(
            `${name}/updatePassword`,
            async function (data, { dispatch }) {
                dispatch(alertActions.clear());
                let message;
                try {
                    const headers = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    const response = await customAxios.post(`/open-api/user/savePassword`, data, { headers });
                    // set auth user in redux state
                    // if (response) {
                    //     console.log('message: ' + JSON.stringify(response));
                    // }
                    message = response.data;
                    return message;
                } catch (error) {
                    return error;
                }
            }
        );
    }
}